export const RESET = 'ADDRESS_UPDATE_RESET'
export const SET_ERROR = 'ADDRESS_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'ADDRESS_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'ADDRESS_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'ADDRESS_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'ADDRESS_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'ADDRESS_UPDATE_UPDATE_RETRIEVED'
export const SET_FILES = 'ADDRESS_UPDATE_FILES'
